import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { AppComponent } from '../../../app.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from "primeng/components/common/selectitem";
import { BookService } from "../../../services/book.service";
import { CreateListingCouponModel, ListingCoupon } from '../../../models/inModels/ListingCoupon';
import { MarketplaceCouponsService } from '../../../services/coupon/marketplace-coupon.service';

@Component({
	selector: 'app-coupons-create',
	templateUrl: './coupons-create.component.html',
	styleUrls: ['./coupons-create.component.css']
})
export class MarketplaceCouponsCreateComponent implements OnInit {
	modelCreate: CreateListingCouponModel;
	loading = false;
	msg: Message[];
	coupon: ListingCoupon;
	couponCode: string;
	createCustomCode: string;
	binaryValue: number;
	form: FormGroup;
	products: SelectItem[];
	selectedProduct: SelectItem;

	constructor(
		private router: Router,
		private app: AppComponent,
		private couponsService: MarketplaceCouponsService,
		private bookService: BookService,
		private formBuilder: FormBuilder) {
		this.modelCreate = new CreateListingCouponModel();
		this.modelCreate.Type = 'Fixed';
		this.modelCreate.PercentageDiscount = 0;
	}

	ngOnInit() {
		this.form = this.formBuilder.group({
			binaryInput: ['', Validators.pattern('[0-1]')]
		});
	}

	goBack() {
		this.router.navigate(['/listing-coupons']);
	}

	create(): void {
		this.loading = true;
		console.log(this.modelCreate);
		// this.modelCreate.RedemptionCount = this.binaryValue;
		this.couponsService.create(this.modelCreate)
			.subscribe(
				coupon => {
					this.coupon = coupon;
					this.loading = false;
					console.log(coupon);
					this.goBack();
					this.msg = [];
					this.msg.push({ severity: 'success', summary: 'Success', detail: 'Coupon Created' });
				},
				error => {
					this.loading = false;
					this.msg = [];
					this.msg.push({ severity: 'error', summary: 'Error', detail: error });
				});

	}

	validateBinaryInput(event: any) {
		const inputChar = String.fromCharCode(event.charCode);
		if (inputChar !== '0' && inputChar !== '1') {
			event.preventDefault();
			this.showErrorMessage();
		}
	}

	showErrorMessage() {
		this.msg = [];
		this.msg.push({ severity: 'error', summary: 'Error', detail: 'Please enter 0 or 1.' });
		setTimeout(() => {
			this.msg = [];
		}, 4000);
	}

	initDropDown(event) {
		this.bookService.getDropdown(event).then(
			x => {
				this.products = x;
			},
			error => {
				this.msg = [];
				this.msg.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/marketplace-coupons/coupons-create/coupons-create.component.ts